export const SET_STATS = "SET_STATS";
export const RESET_STATE = "RESET_STATE";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_SETTINGS_DATA_STATUS = "SET_SETTINGS_DATA_STATUS";
export const SET_FEATURES = "SET_FEATURES";
export const SET_FEATURES_DATA_STATUS = "SET_FEATURES_DATA_STATUS";
export const SET_CREDENTIALS = "SET_CREDENTIALS";
export const SET_PROCESSED_STATS = "SET_PROCESSED_STATS";
export const SET_PROCESSED_STATS_STATUS = "SET_PROCESSED_STATS_STATUS";
export const SET_PROCESSED_STATS_LAST_FETCHED = "SET_PROCESSED_STATS_LAST_FETCHED";
export const SET_PER_SERVER_PROCESSED_STATS = "SET_PER_SERVER_PROCESSED_STATS";
export const SET_PER_SERVER_PROCESSED_STATS_STATUS = "SET_PER_SERVER_PROCESSED_STATS_STATUS";
export const SET_PER_SERVER_PROCESSED_STATS_LAST_FETCHED = "SET_PER_SERVER_PROCESSED_STATS_LAST_FETCHED";
export const SET_CACHE_AUTH = "SET_CACHE_AUTH";
export const SET_TIME_RANGE = "SET_TIME_RANGE";
export const SET_LAYOUT = "SET_LAYOUT";
export const SET_PROMO_BANNER_DISMISSED = "SET_PROMO_BANNER_DISMISSED";
export const SET_MOBILE_MENU_OPEN = "SET_MOBILE_MENU_OPEN";
export const SET_ACTIVE_CACHE_ID = "SET_ACTIVE_CACHE_ID";
export const SET_ACTIVE_PREFIX_ID = "SET_ACTIVE_PREFIX_ID";
export const SET_COMPOUND_STATS_STATUS = "SET_COMPOUND_STATS_STATUS";
export const SET_COMPOUND_STATS_LAST_FETCHED = "SET_COMPOUND_STATS_LAST_FETCHED";
export const SET_PREFIX_STATS_STATUS = "SET_PREFIX_STATS_STATUS";
export const SET_PREFIX_STATS_LAST_FETCHED = "SET_PREFIX_STATS_LAST_FETCHED";
export const SET_POPULAR_ITEMS_STATUS = "SET_POPULAR_ITEMS_STATUS";
export const SET_POPULAR_ITEMS_LAST_FETCHED = "SET_POPULAR_ITEMS_LAST_FETCHED";
export const SET_PREFIX_POPULAR_ITEMS_STATUS = "SET_PREFIX_POPULAR_ITEMS_STATUS";
export const SET_PREFIX_POPULAR_ITEMS_LAST_FETCHED = "SET_PREFIX_POPULAR_ITEMS_LAST_FETCHED";
export const NOTIFICATION_PUSH = "NOTIFICATION_PUSH";
export const NOTIFICATION_DELETE = "NOTIFICATION_DELETE";
export const SET_ALERTS = "SET_ALERTS";
export const SET_DELIVERY_CONFIGS = "SET_DELIVERY_CONFIGS";
export const SET_SHOW_ADD_DELIVERY_CONFIG = "SET_SHOW_ADD_DELIVERY_CONFIG";
export const SET_SMTP_CONFIG = "SET_SMTP_CONFIG";
export const SET_SMTP_CONFIG_IS_DEFAULT = "SET_SMTP_CONFIG_IS_DEFAULT";
export const SET_LOGS = "SET_LOGS";
export const SET_SLAB_STATS = "SET_SLAB_STATS";
export const SET_PROCESSED_SLAB_STATS = "SET_PROCESSED_SLAB_STATS";
export const SET_PROCESSED_SLAB_STATS_FETCHED = "SET_PROCESSED_SLAB_STATS_FETCHED";
export const SET_COMPOUND_STATS = "SET_COMPOUND_STATS";
export const SET_FETCHING_COMPOUND_STATS = "SET_FETCHING_COMPOUND_STATS";
export const SET_PREFIXES = "SET_PREFIXES";
export const SET_POPULAR_ITEMS = "SET_POPULAR_ITEMS";
export const SET_PREFIX_POPULAR_ITEMS = "SET_PREFIX_POPULAR_ITEMS";
export const SET_PREFIX_STATS = "SET_PREFIX_STATS";
export const SET_CURRENT_KEY = "SET_CURRENT_KEY";
export const RESET_CURRENT_KEY = "RESET_CURRENT_KEY";
export const SET_KEY_STATS = "SET_KEY_STATS";
export const SET_KEY_STATS_SERIES = "SET_KEY_STATS_SERIES";
export const SET_SHOW_ADD_PREFIX = "SET_SHOW_ADD_PREFIX";

// CacheSight
export const LOGOUT = "LOGOUT";
export const AUTO_LOGOUT = "AUTO_LOGOUT";
export const SET_CACHES = "SET_CACHES";
export const SET_SERVERS = "SET_SERVERS";
